import React from 'react'
import Icon from 'Core/Components/Icon'

const CopyButton = ({ text, style, ...rest }) => {
    return (
        <div
            style={{ display: 'inline-block', margin: '-1px 0 -1px 5px', padding: 3, float: 'right', ...style }}
            onClick={() =>  navigator.clipboard.writeText(text)}
            className="copy-effect">
            <Icon
                fa="copy"
                style={{ marginRight: 8 }}
            />
        </div>
    )
}

export default CopyButton;



// WEBPACK FOOTER //
// ./client/Core/Components/CopyButton.jsx